/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_No_Presets_TextInputs */



/**
* | output |
* | --- |
* | "No presets saved" |
*
* @param {Preset_Manager_No_Presets_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_no_presets_text = /** @type {((inputs?: Preset_Manager_No_Presets_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_No_Presets_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun preset enregistre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Voreinstellungen gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun preset salvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предустановки не сохранены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ajustes preestablecidos guardados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未保存任何预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが保存されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्रीसेट सहेजा नहीं गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma predefinição salva")
	return /** @type {LocalizedString} */ ("No presets saved")
});